import type { DraftOutcome } from "../api/types.js";

/**
 * DCTA-222 (docs/specs/fe-explained-dcta222.md) — Umakhan's live test, 14 Oct: "…and invest 0 to apple stocks. How do you do
 * the investment part." The bank answers a how-question asked beside an errand with its own fixed sentence (HOW-EXPLAIN,
 * never model text) in `explained[]`, and the errand carries on. Each entry is one assistant line, drawn verbatim BEFORE the
 * question, card or refusal of the same response; its `speech_read` is said by the read pointer (`{part: "reply", read}`),
 * as an executed read's is. No chip, no button: an explanation is not an action.
 */
export interface ExplainedLine {
  /** The bank's sentence, as given — set as text, never markup. */
  readonly line: string;
  /** The read kind that speaks exactly `line`; absent, the line is drawn and not said. */
  readonly read?: string;
}

const text = (v: unknown): string | undefined => (typeof v === "string" && v !== "" ? v : undefined);

/** The response's explanations, in the bank's order; an entry with no sentence is not drawn (and so not said). */
export function explainedOf(outcome: Pick<DraftOutcome, "explained">): ExplainedLine[] {
  const list: unknown = outcome.explained;
  if (!Array.isArray(list)) return [];
  return list.flatMap((e: unknown) => {
    if (typeof e !== "object" || e === null) return [];
    const entry = e as Record<string, unknown>;
    const line = text(entry["answer_line"]);
    if (line === undefined) return [];
    const read = text(entry["speech_read"]);
    return [read === undefined ? { line } : { line, read }];
  });
}
